import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-planning.light.webp";
import imageDark from "../images/national-planning.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-planning",
  displayName: `National Planning`,
  datasetProductCode: `GEOSCAPE PLANNING`,
  subtitle: `Detailed Land Parcel Planning Classification and Insights.`,
  shortDescription: `Planning provides detailed planning zone codes and descriptions for parcels of land across Australia by representing the detailed planning classification for each parcel as well as links to the relevant planning scheme/instrument. Planning provides a simple lookup for the classification on sites nationally, as well as linkages to enable further understanding of a site's potential. Planning is created through combining Geoscape Australia's National Cadastre product with Planning Zones defined by a State, Territory or Local Government.
Planning zones provide a method to divide land and describe the types of development that may occur at a location, and often describe other developmental requirements such as the height, setback or form of the structures that can be built. Planning zones allow State, Territory and local Governments to facilitate urban planning and control the development of land.

Through representing the planning classification from a planning zone at a Cadastre cadastral parcel level, Planning provides a granular representation of the potential for development at each site, alongside URL linkages to enable further research directly from the authoritative definition.
Planning is released on a quarterly schedule against the latest Cadastre data, with planning data updated bi-annually`,
  metadata: {
    dateAdded: 1625011200000,
    dataType: ["Aspatial"],
    theme: `Land Parcels`,
    totalFeatureCount: 15329172,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/planning.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/planning.html`,
  imageLight,
  imageDark,
  searchTags: `National Planning Geoscape Planning Design Land Use Planning Planning Schemes Regulations Scheme Linkages Urban Development Zoning`,
  detail: () => import("../details/national-planning").then((m) => m.detail),
};

export default entry;
